import {
  Modal,
  Button,
  Table,
  InputGroup,
  Form,
  Dropdown,
} from "react-bootstrap";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useFormik } from "formik";
import Select from "react-select";
import { Popover } from "react-tiny-popover";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";
import currency from "currency.js";
import DateTime from "react-datetime";
import moment from "moment";

import { useAuth } from "../../hooks/useAuth";
import "../../assets/scss/scoped/issueItem.scss";
import ConfirmDialog from "../ConfirmDialogue";
import { fetchActionsUtil } from "../../utils/helpers";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { DeleteIcon, TagSimpleIcon } from "../Icons";
import ModalLoader from "../utils/ModalLoader";
import { backendApis } from "../../config";
// import CachedIcon from "mdi-react/CachedIcon";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import GetTemplateModal from "./GetProductionTemplateModal";
import ShowProjectedItemsDialog from "./ShowProjectedItems";
import { resolveSendToUrl } from "../../utils/functions";

const initialValues = {
  RequesterName: "",
  Requester: "",
  UserName: "",
  plant: "",
  Warehouse: "",
  WarehouseName: "",
  issueTo: "",
  type: "",
  stagingId: "",
  equipment: "",
};

const issuedToData = [
  {
    value: "",
    label: "Select Issue To",
  },
  ...backendApis.map((el) => ({
    value: el.name,
    label: el.name,
  })),
];

const issuedTypes = [
  {
    value: "",
    label: "Select Issue Type",
  },
  {
    value: "Plant",
    label: "Plant",
  },
  {
    value: "Warehouse",
    label: "Warehouse",
  },
  {
    value: "Sales",
    label: "Sales Inventory",
  },
];

// ─── Field validation config (easy to extend) ────────────────────────────────
const REQUIRED_ITEM_FIELDS = [
  "Quantity",
  "UnitCost",
  "Date_Log",
  "issueTo",
  "RequesterName",
];

const FIELD_ERROR_MESSAGES = {
  Warehouse: "The Location field is missing",
  issueTo: "The Issue to field is missing",
  receivingofficer: "The Receiving In/By field is missing",
  Quantity: "The Quantity field is missing or invalid",
};

// ─── Error display helper ─────────────────────────────────────────────────────
// const showValidationErrors = (errors) => {
//   toast.error(
//     <div>
//       <p className="font-semibold mb-1">Please fix the following issues:</p>
//       <ul className="list-disc pl-4 space-y-1">
//         {errors.map((err, i) => (
//           <li key={i} className="text-sm">
//             {err}
//           </li>
//         ))}
//       </ul>
//     </div>,
//     {
//       position: "top-center",
//       autoClose: false, // keep open until user dismisses
//       style: { minWidth: "360px" },
//     },
//   );
// };

export const CreateProductLogModal = (props) => {
  const [showItemsPopover, setShowItemsPopover] = useState(false);
  const [showPopoverItems, setShowPopoverItems] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [activeTableIndex, setActiveTableIndex] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  //=====================
  const [allStaff, setAllStaff] = useState([]);
  const [allWarehouse, setAllWarehouse] = useState([]);
  const [plantStorages, setPlantStorages] = useState([]);
  // ====================

  const { backendUrl, token, user } = useAuth();

  const handleInputChange = ({ index, name, value }) => {
    const oldTableData = [...tableData];
    oldTableData[index][name] = value;

    // Calculate total amount if quantity or unit cost changes
    if (name === "Quantity" || name === "UnitCost") {
      const quantity =
        name === "Quantity"
          ? parseFloat(value) || 0
          : parseFloat(oldTableData[index].Quantity) || 0;
      const unitCost =
        name === "UnitCost"
          ? parseFloat(value) || 0
          : parseFloat(oldTableData[index].UnitCost) || 0;
      oldTableData[index].totalAmount = quantity * unitCost;
    }

    setTableData(oldTableData);
  };

  const [isLoadingAddToCart, setIsLoadingAddToCart] = useState(false);

  const plantLocal = JSON.parse(window.localStorage.getItem("plantDetails"));

  const plantId = plantLocal.PLID;

  const { data: equipments } = useQuery(
    ["PLANT_EQUIPMENT", { plantId }],
    () =>
      fetchActionsUtil(
        `${backendUrl}/api/production/equipments/?plant=${plantId}`,
      ),
    {
      keepPreviousData: true,
    },
  );

  const sendProductLog = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/production/product-log/${plantId}`,
        "POST",
        token,
        payload,
      ),
    {
      onSuccess: ({ message, data }) => {
        toast.success("Sent to C of A");

        formik.resetForm({
          values: {
            ...initialValues,
          },
        });

        setTableData([]);
        props.refetchMain();
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    },
  );

  const formik = useFormik({
    initialValues,

    onSubmit: async (values) => {
      const errors = [];

      // ── Guard: empty table ──────────────────────────────────────────────────
      if (!tableData.length) return toast.error("Add Items");

      // ── Guard: Validate the Target output ─────────────────────────────────────
      const results = await fetchActionsUtil(
        `${backendUrl}/api/production/check-output-target`,
        "POST",
        token,
        { tableData, plantId },
      );

      if (results?.length > 0) {
        // return showValidationErrors(results);
        results?.map((el) => errors.push(el));
      }

      // ── Guard: missing required fields ─────────────────────────────────────
      const hasInvalidItems = tableData.some((item) =>
        REQUIRED_ITEM_FIELDS.some((field) => !item[field]),
      );
      if (hasInvalidItems)
        return toast.error("Please fill all required fields for each item");

      // ── Build modified table + collect errors in one pass ──────────────────

      const tableDataModified = [];

      for (const el of tableData) {
        // Field-level validation
        const fieldError = !el.Warehouse
          ? FIELD_ERROR_MESSAGES.Warehouse
          : !el.issueTo
          ? FIELD_ERROR_MESSAGES.issueTo
          : !el.receivingofficer
          ? FIELD_ERROR_MESSAGES.receivingofficer
          : !el.Quantity || parseFloat(el.Quantity) <= 0
          ? FIELD_ERROR_MESSAGES.Quantity
          : null;

        if (fieldError) {
          errors.push(`${el.Item_Name?.toUpperCase()}: ${fieldError}`);
          continue;
        }

        // Resolve backend
        const sendTo = backendApis.find((item) => item.name === el.issueTo);
        if (!sendTo) {
          toast.warning(`No backend found for ${el.issueTo}`);
          tableDataModified.push(el);
          continue;
        }

        const sendToUrl = resolveSendToUrl(el, sendTo);
        const isSales = el.Requester === "" || el.Requester === "Sales";

        tableDataModified.push({
          ...el,
          sendForApproval: true,
          sendTo: sendToUrl,
          url: sendTo,
          ...(isSales && { Warehouse: "", WarehouseName: "" }),
        });
      }

      // ── Show validation errors and bail ────────────────────────────────────
      if (errors.length) {
        // return showValidationErrors(errors);

        // console.log(errors);

        return ConfirmDialog({
          type: "danger",
          title: "Unable to perform action",
          description: (
            <div>
              <ul className="list-disc pl-4 space-y-1">
                {errors?.map((err, i) => (
                  <li key={i} className="text-sm">
                    {err}
                  </li>
                ))}
              </ul>
            </div>
          ),
          cancelText: "Ok",
          choice: false,
        });
      }

      console.log(tableDataModified);

      // ── Confirm and submit ─────────────────────────────────────────────────
      const confirmed = await ConfirmDialog({
        title: "Save Production",
        description: "Are you sure you want to save this production?",
      });

      if (confirmed) sendProductLog.mutate(tableDataModified);
    },
  });

  // ─── Shared: validate quantities against backend ──────────────────────────────
  const validateQuantities = useCallback(
    async (items) => {
      const results = await Promise.all(
        items.map((item) =>
          fetchActionsUtil(
            `${backendUrl}/api/production/check-quantity-items/${plantId}`,
            "POST",
            token,
            item,
          ),
        ),
      );

      const errors = results
        .flatMap(({ message }) => message)
        .filter(Boolean)
        .map((msg, i) => (
          <div className="my-2" key={i}>
            {i + 1}. {msg?.message}
          </div>
        ));

      setErrorMessage(errors.length ? errors : null);
      return errors.length === 0; // true = all valid
    },
    [backendUrl, plantId, token],
  );

  const addToTable = useCallback(
    async (el, index) => {
      // ── Guards ────────────────────────────────────────────────────────────────
      if (!el.Bar_Code) return toast.error("Enter Item ID");
      if (!el.Quantity) return toast.error("Enter Quantity");

      // ── Project dialog ────────────────────────────────────────────────────────
      const newData = await ShowProjectedItemsDialog({ mainData: el });
      if (!newData) return;

      const finalItem = {
        ...newData,
        prod_profiles: newData.prod_profiles?.map((p) => ({
          ...p,
          quantity: parseFloat(p.actual) + parseFloat(p.damage),
        })),
      };

      // ── Validate quantity (reuse shared helper) ───────────────────────────────
      try {
        setIsLoadingAddToCart(true);
        const isValid = await validateQuantities([finalItem]);
        if (!isValid) return;
      } catch (err) {
        console.error("addToTable quantity check failed:", err);
        return;
      } finally {
        setIsLoadingAddToCart(false);
      }

      // ── Update table immutably via functional setter (no stale closure) ───────
      setTableData((prev) => {
        const updated = [...prev];
        updated[index] = finalItem; // replace at exact index, no duplication
        return updated;
      });
    },
    [validateQuantities],
  );

  const buildItem = useCallback(
    (item) => ({
      ...item,
      Quantity: item.Quantity || 1,
      UnitCost: item.UnitCost || 0,
      Date_Log: moment(new Date()),
      UserName: user.username,
      plant: plantId,
      issueTo: formik.values.issueTo || "",
      Requester: formik.values.Requester || "",
      RequesterName: formik.values.RequesterName || "",
      Warehouse: formik.values.Warehouse || "",
      WarehouseName: formik.values.WarehouseName || "",
      type: formik.values.type || "",
      stagingId: formik.values.stagingId,
      equipment: formik.values.equipment,
      totalAmount:
        (parseFloat(item.Quantity) || 1) * (parseFloat(item.UnitCost) || 0),
    }),
    [user, plantId, formik.values],
  );

  // ─── Shared: merge new items into existing table (no stale closure) ───────────
  const mergeTableItems = useCallback((newItems) => {
    setTableData((prev) => {
      const updated = [...prev];
      newItems.forEach((newItem) => {
        const idx = updated.findIndex((t) => t.Bar_Code === newItem.Bar_Code);
        idx !== -1 ? (updated[idx] = newItem) : updated.push(newItem);
      });
      return updated;
    });
  }, []);

  // ─── Main handler ─────────────────────────────────────────────────────────────
  const handleSelectedItem = useCallback(
    async (items) => {
      setShowItemsPopover(false);
      setShowPopoverItems(false);

      // ── Array path (bulk from product plan) ────────────────────────────────
      if (Array.isArray(items)) {
        const validItems = [];

        for (const item of items) {
          if (!item?.accountName || !item?.DetailType) {
            toast.error(`Add account to template for item: ${item.Item_Name}`);
            continue;
          }
          validItems.push(buildItem(item));
        }

        if (!validItems.length) return;

        try {
          setIsLoadingAddToCart(true);
          await validateQuantities(validItems);
        } catch (err) {
          console.error("Quantity validation failed:", err);
        } finally {
          setIsLoadingAddToCart(false);
        }

        mergeTableItems(validItems);
        return;
      }

      // ── Single item path ────────────────────────────────────────────────────
      if (!items?.accountName || !items?.DetailType) {
        return toast.error("Add account to this template");
      }

      const newItem = buildItem(items);
      const newData = await ShowProjectedItemsDialog({ mainData: newItem });
      if (!newData) return;

      const prod_profiles = newData.prod_profiles?.map((el) => ({
        ...el,
        quantity: parseFloat(el.actual) + parseFloat(el.damage),
      }));

      const finalItem = { ...newData, prod_profiles };

      try {
        setIsLoadingAddToCart(true);
        const isValid = await validateQuantities([finalItem]);
        if (!isValid) return;
      } catch (err) {
        console.error("Quantity validation failed:", err);
      } finally {
        setIsLoadingAddToCart(false);
      }

      mergeTableItems([finalItem]);
    },
    [buildItem, validateQuantities, mergeTableItems],
  );

  const onDelete = (barcode) => {
    const item = tableData.filter((d) => d.Bar_Code !== barcode);
    setTableData(item);
  };

  const getStaffs = async (name) => {
    let sendTo = "";
    const sendToUrl = `${
      backendApis.find((el) => el.name === name)?.url
    }/api/users`;
    if (sendToUrl) {
      sendTo = sendToUrl || "";
      const staffs = await fetchActionsUtil(sendTo, "GET");
      staffs.staff = staffs.staff.map((el) => ({
        value: `${el.Name}-${el.email}`,
        label: el.Name,
      }));
      setAllStaff([
        {
          value: "",
          label: "Select Staff",
        },
        ...staffs.staff,
      ]);
    }
  };

  const getWarehouse = async (name) => {
    let sendTo = "";

    const sendToUrl = `${
      backendApis.find((el) => el.name === name)?.url
    }/api/warehouse`;

    if (sendToUrl) {
      sendTo = sendToUrl || "";
      const { warehouses = [] } = await fetchActionsUtil(sendTo, "GET");
      const ware = [
        {
          value: "",
          label: "Select Warehouse",
        },

        ...warehouses?.map((el) => ({
          value: el?.W_ID,
          label: el?.W_name,
        })),
      ];
      setAllWarehouse(ware);
    }
  };

  const getPlant = async (name) => {
    let sendTo = "";

    const sendToUrl = `${
      backendApis.find((el) => el.name === name)?.url
    }/api/production/plants`;

    if (sendToUrl) {
      sendTo = sendToUrl || "";
      const { allPlants = [] } = await fetchActionsUtil(sendTo, "GET");

      const storages = allPlants?.flat()?.map((el) => ({
        [el?.Plant_Name]: el?.storageBin || [],
      }));

      const ware = [
        {
          value: "",
          label: "Select Plant",
        },
        ...allPlants?.flat()?.map((el) => ({
          value: el?.Plant_ID,
          label: el.Plant_Name,
        })),
      ];
      setPlantStorages(storages);
      setAllWarehouse(ware);
    }
  };

  // Update all table items when form values change
  const updateAllTableItems = useCallback((field, value) => {
    setTableData((prev) => prev.map((item) => ({ ...item, [field]: value })));
  }, []);

  // ─── For syncing multiple fields in one pass (one re-render) ─────────────────
  const updateAllTableItemsMany = useCallback((fields) => {
    setTableData((prev) => prev.map((item) => ({ ...item, ...fields })));
  }, []);

  // ─── Helper: sync a field to both formik and table ───────────────────────────

  const syncFields = useCallback(
    (fields) => {
      Object.entries(fields).forEach(([field, value]) => {
        formik.setFieldValue(field, value);
      });
      updateAllTableItemsMany(fields); // ← single table update instead of N
    },
    [formik, updateAllTableItemsMany],
  );

  // ─── Handlers ────────────────────────────────────────────────────────────────
  const onChangeLocation = useCallback(
    ({ value, label }) => {
      if (formik.values.type === "Plant") {
        const found = plantStorages?.find((item) => item[label])?.[label] ?? [];
        const storages = found.map((el) => ({
          value: el.Storage_ID,
          label: el.Storage_Name,
        }));
        setAllStaff([{ value: "", label: "Select Storage" }, ...storages]);
      } else if (formik.values.type === "Warehouse") {
        getStaffs(formik.values.issueTo);
      }

      syncFields({
        Warehouse: value,
        WarehouseName: label,
        Requester: value,
      });
    },
    [formik.values.type, formik.values.issueTo, plantStorages, syncFields],
  );

  const onIssueTo = useCallback(
    (value) => {
      syncFields({ issueTo: value });

      const typeActions = {
        Plant: () => getPlant(value),
        Warehouse: () => getWarehouse(value),
      };

      if (typeActions[formik.values.type]) {
        typeActions[formik.values.type]();
      } else {
        getStaffs(value);
        setAllWarehouse([
          {
            value: "Sales",
            label: "Sales Inventory",
          },
        ]);
        syncFields({
          Warehouse: "Sales",
          WarehouseName: "Sales",
          Requester: "Sales",
        });
      }
    },
    [formik.values.type, syncFields],
  );

  const onSelectType = useCallback(
    (value) => {
      const emptyFields = {
        ...formik.values,
        receivingofficer: "",
        RequesterName: "",
        issueTo: "",
        Warehouse: "",
        WarehouseName: "",
        Requester: "",
        stagingId: "",
        equipment: "",
      };

      formik.resetForm(emptyFields);
      syncFields({ ...emptyFields, type: value });
    },
    [formik, syncFields],
  );

  const { data } = useQuery(
    ["PRODUCTION_STAGES", { plantId }],
    () => fetchActionsUtil(`${backendUrl}/api/production/stages`, "GET"),
    {
      keepPreviousData: true,
    },
  );

  const stages = useMemo(() => {
    return [
      {
        value: "",
        label: "Select Plant Staging",
      },
      ...(data?.data ?? [])?.map((el) => ({
        label: el?.name,
        value: el?.stage_id,
      })),
    ];
  }, [data]);

  const resolveStorages = useCallback(
    (locationName) => {
      const found =
        plantStorages?.find((el) => el[locationName])?.[locationName] ?? [];
      return [
        { value: "", label: "Select Storage" },
        ...found.map((el) => ({
          value: el.Storage_ID,
          label: el.Storage_Name,
        })),
      ];
    },
    [plantStorages],
  );

  const handleSelections = async ({ type, issueTo }) => {
    if (!type || !issueTo) return;

    const typeActions = {
      Plant: async () => await getPlant(issueTo),
      Warehouse: async () => await getWarehouse(issueTo),
      Sales: () => {
        getStaffs(issueTo);
        setAllWarehouse([{ value: "Sales", label: "Sales Inventory" }]);
      },
    };

    typeActions[type]?.();
  };

  const handleStaging = async (id) => {
    const activeStage = data?.data?.find((el) => el?.stage_id === id);
    const plantIndex = activeStage?.stages?.findIndex(
      (el) => el?.location === plantId,
    );

    if (plantIndex < 0) return;

    const nextStage = activeStage?.stages?.[plantIndex + 1];

    // console.log({ activeStage, plantIndex, nextStage });

    const type = nextStage?.type;
    const issueTo = nextStage?.issueTo;

    await handleSelections({ type, issueTo });

    syncFields({
      Warehouse: nextStage?.location,
      WarehouseName: nextStage?.locationName,
      Requester: nextStage?.location,
      receivingofficer: nextStage?.receiver,
      RequesterName: nextStage?.receiver,
      issueTo,
      type,
      stagingId: id,
    });
  };

  const formikValues = formik.values;
  useEffect(() => {
    if (formikValues.type === "Plant") {
      setAllStaff(resolveStorages(formikValues.WarehouseName));
    } else if (formikValues.type === "Warehouse") {
      getStaffs(formikValues.issueTo);
    }
  }, [formikValues, resolveStorages]);

  const mainEquipments = useMemo(() => {
    return [
      {
        value: "",
        label: "Select Equipment",
      },
      ...(equipments?.data ?? [])?.map((el) => ({
        label: el?.Item_Name,
        value: el?.Serial_Number,
      })),
    ];
  }, [equipments]);

  return (
    <Modal
      onHide={props.onHide}
      show={props.show}
      backdropClassName={`global-backdrop`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="my-style-modal"
      animation={false}
      enforceFocus={false}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div>
            <h1>Product Log</h1>
          </div>

          <p>Add product log by filling in the following forms.</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="container">
            <div>
              <div className="form-relative">
                {/*  */}
                <div className="row">
                  <div className="col-6 mb-3">
                    <label className="form-label mb-2">Equipments</label>
                    <Select
                      classNamePrefix={"form-select"}
                      isSearchable={true}
                      value={mainEquipments?.find(
                        (el) => el.value === formik.values.equipment,
                      )}
                      onChange={({ value }) => {
                        syncFields({
                          equipment: value,
                        });
                      }}
                      options={mainEquipments}
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label mb-2">Activate Staging</label>
                    <Select
                      classNamePrefix={"form-select"}
                      isSearchable={true}
                      value={stages?.find(
                        (el) => el.value === formik.values.stagingId,
                      )}
                      onChange={({ value }) => {
                        handleStaging(value);
                      }}
                      options={stages}
                    />
                  </div>

                  <div className="col-6 mb-3">
                    <label className="form-label">Select Plan</label>
                    <InputGroup>
                      <Form.Control
                        placeholder="Click search to select plan or item"
                        value=""
                        readOnly
                      />

                      <Popover
                        isOpen={showItemsPopover}
                        onClickOutside={() => setShowItemsPopover(false)}
                        content={() => (
                          <GetTemplateModal
                            handleSelectedItem={(items) => {
                              handleSelectedItem(items);
                            }}
                            productPlan
                            plant={props?.plant}
                          />
                        )}
                        position="bottom"
                      >
                        <InputGroup.Text
                          onClick={() => setShowItemsPopover(!showItemsPopover)}
                        >
                          <MagnifyIcon />
                        </InputGroup.Text>
                      </Popover>
                    </InputGroup>
                  </div>

                  <div className="col-6 mb-3">
                    <label className="form-label">Individual Items</label>
                    <InputGroup>
                      <Form.Control
                        placeholder="Click search to select individual items"
                        value=""
                        readOnly
                      />

                      <Popover
                        isOpen={showPopoverItems}
                        onClickOutside={() => setShowPopoverItems(false)}
                        content={() => (
                          <GetTemplateModal
                            handleSelectedItem={(items) => {
                              handleSelectedItem(items);
                            }}
                          />
                        )}
                        position="bottom"
                      >
                        <InputGroup.Text
                          onClick={() => setShowPopoverItems(!showPopoverItems)}
                        >
                          <MagnifyIcon />
                        </InputGroup.Text>
                      </Popover>
                    </InputGroup>
                  </div>
                </div>

                <div className="row">
                  <div className="col-3 mb-3">
                    <label className="form-label mb-2">Issuing Type</label>
                    <Select
                      classNamePrefix={"form-select"}
                      isSearchable={true}
                      isLoading={props?.isLoading}
                      name="type"
                      value={issuedTypes.find(
                        (el) => el.value === formik.values.type,
                      )}
                      onChange={({ value }) => {
                        onSelectType(value);
                      }}
                      options={issuedTypes}
                      isDisabled={!tableData?.length > 0}
                    />

                    {formik.touched.type && !!formik.errors.type ? (
                      <span className="custom-invalid-feedback">
                        {formik.errors.type}
                      </span>
                    ) : null}
                  </div>

                  <div className="col-3 mb-3">
                    <label className="form-label mb-0">
                      Branch
                      {/* <span onClick={() => props?.refetchMain()}>
                        <CachedIcon style={{ width: "20px" }} />
                      </span> */}
                    </label>
                    <Select
                      classNamePrefix={"form-select"}
                      isSearchable={true}
                      isLoading={props?.isLoading}
                      value={issuedToData.find(
                        (el) => el.value === formik.values.issueTo,
                      )}
                      onChange={({ value }) => {
                        onIssueTo(value);
                      }}
                      options={issuedToData}
                      isDisabled={formik.values.type === ""}
                    />

                    {formik.touched.issueTo && !!formik.errors.issueTo ? (
                      <span className="custom-invalid-feedback">
                        {formik.errors.issueTo}
                      </span>
                    ) : null}
                  </div>

                  <div className="col-3 mb-3">
                    <label className="form-label mb-0">
                      {formik.values.type || " "}
                      {/* <span onClick={() => props?.refetchMain()}>
                        <CachedIcon style={{ width: "20px" }} />
                      </span> */}
                    </label>
                    <Select
                      classNamePrefix={"form-select"}
                      isSearchable={true}
                      isLoading={props?.isLoading}
                      value={allWarehouse.find(
                        (el) => el.value === formik.values.Warehouse,
                      )}
                      onChange={({ value, label }) => {
                        onChangeLocation({ value, label });
                      }}
                      options={allWarehouse}
                      isDisabled={formik.values.type === "Sales"}
                    />

                    {formik.touched.Warehouse && !!formik.errors.Warehouse ? (
                      <span className="custom-invalid-feedback">
                        {formik.errors.Warehouse}
                      </span>
                    ) : null}
                  </div>

                  <div className="col-3 mb-3">
                    <label className="form-label">
                      {formik.values.type === "Plant"
                        ? "Storage Bins"
                        : "Staffs"}
                      {/* <span onClick={() => props?.refetchMain()}>
                        <CachedIcon />
                      </span> */}
                    </label>
                    <Select
                      classNamePrefix={"form-select"}
                      isSearchable={true}
                      isLoading={props?.isLoading}
                      value={allStaff.find(
                        (el) => el.value === formik.values.receivingofficer,
                      )}
                      onChange={({ value }) => {
                        formik.setFieldValue("receivingofficer", value);
                        formik.setFieldValue("RequesterName", value);
                        updateAllTableItems("RequesterName", value);
                        updateAllTableItems("receivingofficer", value);
                      }}
                      options={allStaff}
                    />

                    {formik.touched.receivingofficer &&
                    !!formik.errors.receivingofficer ? (
                      <span className="custom-invalid-feedback">
                        {formik.errors.receivingofficer}
                      </span>
                    ) : null}
                  </div>
                </div>

                {/* Table */}
                <div className="mt-5 mb-4">
                  <Table
                    responsive
                    borderless
                    striped
                    className="product-table"
                  >
                    <thead>
                      <tr>
                        <th />
                        <th>S/N</th>
                        <th>Bar Code</th>
                        <th>Name</th>
                        <th>Quantity</th>
                        <th>UOM</th>
                        <th>Unit Cost</th>
                        <th>Production Date</th>
                        <th>Sub Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.length > 0 &&
                        tableData?.map((el, index) => (
                          <tr
                            key={index}
                            className={`${activeTableIndex === index &&
                              "active-row"}`}
                            onClick={() =>
                              activeTableIndex !== index &&
                              setActiveTableIndex(index)
                            }
                          >
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant=""
                                  className="bg-white border-0"
                                  bsPrefix="print more"
                                  style={{ height: "3px" }}
                                >
                                  <DotsHorizontalIcon />
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                  popperConfig={{
                                    strategy: "fixed",
                                  }}
                                  renderOnMount
                                  className="dropdown-with-icons"
                                >
                                  <Dropdown.Item
                                    as="button"
                                    onClick={() => onDelete(el.Bar_Code)}
                                  >
                                    <DeleteIcon className="text-danger" />
                                    Delete
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    as="button"
                                    onClick={() => addToTable(el, index)}
                                  >
                                    <TagSimpleIcon className="text-light" />
                                    Edit
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            <td>{index + 1}</td>
                            <td>{el.Bar_Code}</td>
                            <td>{el.Item_Name}</td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                type="number"
                                value={el.Quantity}
                                onKeyDown={(e) =>
                                  e.key === "Enter" && e.target.blur()
                                }
                                name="Quantity"
                                onChange={(e) =>
                                  handleInputChange({
                                    index,
                                    name: e.target.name,
                                    value: e.target.value,
                                  })
                                }
                              />
                            </td>
                            <td>{el?.Product_Model}</td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                type="number"
                                value={el.UnitCost}
                                onKeyDown={(e) =>
                                  e.key === "Enter" && e.target.blur()
                                }
                                name="UnitCost"
                                onChange={(e) =>
                                  handleInputChange({
                                    index,
                                    name: e.target.name,
                                    value: e.target.value,
                                  })
                                }
                              />
                            </td>
                            <td>
                              <DateTime
                                timeFormat={false}
                                closeOnSelect={true}
                                closeOnClickOutside={true}
                                dateFormat="MMM DD, YYYY"
                                inputProps={{
                                  className: `form-control form-control-sm`,
                                  placeholder: "Select date",
                                  readOnly: true,
                                }}
                                value={el.Date_Log}
                                onChange={(date) => {
                                  handleInputChange({
                                    index,
                                    name: "Date_Log",
                                    value: date,
                                  });
                                }}
                              />
                            </td>
                            <td className="d-flex align-items-center">
                              {currency(parseFloat(el?.totalAmount) || 0, {
                                symbol: "",
                              }).format()}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>

                {/*  */}

                {errorMessage && (
                  <div className="d-flex justify-content-center">
                    <p className="text-danger">
                      <b>{errorMessage}</b>
                    </p>
                  </div>
                )}

                <div className="add-to-cart-holder d-flex justify-content-end text-primary mt-5">
                  <div>
                    <Button
                      variant="outline-primary"
                      onClick={formik.handleSubmit}
                      disabled={sendProductLog.isLoading}
                    >
                      {sendProductLog.isLoading
                        ? "Sending..."
                        : " Post Production"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <ModalLoader
              show={sendProductLog.isLoading || isLoadingAddToCart}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
